export const EVENT_OPEN_DEPOSIT = "OPEN_DEPOSIT";
export const EVENT_CLOSE_DEPOSIT = "CLOSE_DEPOSIT";
export const EVENT_GO_TO_SUB_SCREEN = "GO_TO_SUB_SCREEN";
export const EVENT_NATIVE_DEPOSIT_CANCEL = "NATIVE_DEPOSIT_CANCEL";
export const EVENT_NATIVE_DEPOSIT_CLOSE = "NATIVE_DEPOSIT_CLOSE";
export const EVENT_NATIVE_DEPOSIT_TIMEOUT = "NATIVE_DEPOSIT_TIMEOUT";
export const EVENT_NATIVE_DEPOSIT_BACK = "NATIVE_DEPOSIT_BACK";
